import { MOKA_SERVICE_HOST } from '../../constants';

const API_URL = `${MOKA_SERVICE_HOST}/inventory/v1`;
export const GET_LIST_SALES_TYPE = `${API_URL}/sales-type`;

export const CREATE_SALES_TYPE_SINGLE_OUTLET = `${API_URL}/sales-type`;
export const CREATE_SALES_TYPE_ALL_OUTLET = `${API_URL}/sales-type/all-outlets`;
export const GET_DETAIL_SALES_TYPE = (salestypeId) =>
  `${API_URL}/sales-type/${salestypeId}`;
export const UPDATE_SALES_TYPE = (salestypeId) =>
  `${API_URL}/sales-type/${salestypeId}`;
export const DELETE_SALES_TYPE = (id) => `${API_URL}/sales-type/${id}`;
export const UPDATE_STATUS_SALES_TYPE = (id) =>
  `${API_URL}/sales-type/manage-state/${id}`;
export const CHECK_SALES_TYPE_DELETABLE = (id) =>
  `${API_URL}/sales-type/check-deletable/${id}`;
export const FIND_SALES_TYPE_RESERVED_BY_NAME = (name) =>
  `${API_URL}/sales-type-reserved/name/${name}`;
export const GET_SALES_TYPE_DISTINCT_NAME = `${API_URL}/sales-type/name`;
